import { TypographyOptions } from '@material-ui/core/styles/createTypography'
import { Overrides } from '@material-ui/core/styles/overrides'

import { masmovilPalette, llamayaPalette } from './colors'
import { fonts } from './fonts'

const typography: TypographyOptions = {
  h1: {
    fontFamily: fonts.primary,
    fontSize: fonts.size.xhuge,
  },
  h2: {
    fontSize: fonts.size.xlarge,
    fontWeight: 'bold',
    lineHeight: 1.17,
    '&.big': {
      fontSize: fonts.size.huge,
    },
  },
  h3: {
    fontSize: fonts.size.large,
    fontWeight: 'bold',
    letterSpacing: '0.6px',
    lineHeight: 1.2,
  },
  h4: {
    fontSize: fonts.size.base,
    fontWeight: 'bold',
    lineHeight: 1.25,
  },
  h5: {
    fontSize: fonts.size.small,
    fontWeight: 'bold',
  },
  h6: {
    fontSize: fonts.size.xsmall,
    fontWeight: 'bold',
    letterSpacing: '0.67px',
  },
  subtitle1: {
    fontSize: fonts.size.base,
    fontWeight: 'bold',
    lineHeight: 1.5,
  },
  subtitle2: {
    fontSize: fonts.size.base,
    fontWeight: 'bold',
    lineHeight: 1.5,
  },
  body1: {
    fontSize: fonts.size.base,
    lineHeight: 1.2,
  },
  body2: {
    fontSize: fonts.size.small,
    lineHeight: 1.2,
  },
  overline: {
    fontSize: fonts.size.tiny,
    fontWeight: 'bold',
    lineHeight: 1.2,
    letterSpacing: '0.4px',
  },
  caption: {
    fontSize: fonts.size.xsmall,
    fontWeight: 'bold',
    lineHeight: 1.2,
    '&.regular': {
      fontWeight: 'normal',
    },
  },
}

export const typographyOverride: Overrides = {
  MuiTypography: {
    root: {
      '&.card-title': {
        padding: '21px 24px 19px 24px',
      },
      '&.link': {
        fontSize: fonts.size.small,
        fontWeight: 'bold',
        textDecoration: 'underline',
        cursor: 'pointer',
      },
    },
  },
}

const commonTypographyOverride = {
  MuiTypography: {
    root: {
      '&.card-title': {
        padding: '21px 24px 19px 24px',
      },
      '&.link': {
        fontSize: fonts.size.small,
        fontWeight: 'bold',
        textDecoration: 'underline',
        cursor: 'pointer',
      },
    },
  },
}

export const masmovilTypographyOverride: Overrides = {
  MuiTypography: {
    root: {
      ...commonTypographyOverride.MuiTypography.root,
      '&.link': {
        ...commonTypographyOverride.MuiTypography.root['&.link'],
        color: masmovilPalette.link.main,
      },
      '&.link-disabled': {
        ...commonTypographyOverride.MuiTypography.root['&.link'],
        color: masmovilPalette.link.disabled,
        cursor: 'not-allowed',
      },
    },
  },
}

export const llamayaTypographyOverride: Overrides = {
  MuiTypography: {
    root: {
      ...commonTypographyOverride.MuiTypography.root,
      '&.link': {
        ...commonTypographyOverride.MuiTypography.root['&.link'],
        color: llamayaPalette.link.main,
      },
      '&.link-disabled': {
        ...commonTypographyOverride.MuiTypography.root['&.link'],
        color: llamayaPalette.link.disabled,
        cursor: 'not-allowed',
      },
    },
  },
}

export default typography
